import React from "react";
import { useVenue } from "../context/VenueContext";

export default function HomeScreen({ setScreen, onNotif, onOpenProfile }) {
  const { venue, queue, nowPlaying, isPlaying, activeUsers, isVenueMode, playerReady } = useVenue();

  return (
    <div style={{ minHeight: "100vh", background: "#0A0A0A", fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display:ital@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 0; }
        .home-hero { padding: 80px 40px 48px; position: relative; overflow: hidden; text-align: center; }
        .home-hero-glow { position: absolute; inset: 0; background: radial-gradient(ellipse at 50% 30%, rgba(29,185,84,0.08) 0%, transparent 60%); pointer-events: none; }
        .home-venue-name { font-family: 'DM Serif Display', serif; font-size: clamp(36px, 4vw, 52px); color: #ffffff; letter-spacing: -2px; position: relative; z-index: 1; }
        .home-venue-sub { font-size: 12px; color: rgba(255,255,255,0.5); margin-top: 4px; position: relative; z-index: 1; line-height: 1.5; }
        .now-playing-card { margin: 24px auto 0; max-width: 560px; width: 100%; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 14px 16px; display: flex; align-items: center; gap: 12px; cursor: pointer; transition: all 0.2s; position: relative; z-index: 1; }
        .now-playing-card:hover { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.15); transform: translateY(-2px); }
        .now-playing-card:active { transform: scale(0.99); }
        .now-cover { width: 48px; height: 48px; border-radius: 10px; object-fit: cover; flex-shrink: 0; }
        .now-cover-placeholder { width: 48px; height: 48px; border-radius: 10px; background: rgba(255,255,255,0.08); display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
        .action-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; padding: 24px 40px; max-width: 900px; margin: 0 auto; }
        .action-btn { padding: 14px; border-radius: 100px; border: none; cursor: pointer; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 600; transition: all 0.2s; display: flex; align-items: center; justify-content: center; gap: 8px; }
        .action-btn:active { transform: scale(0.97); }
        .action-btn-primary { background: #ffffff; color: #0A0A0A; font-weight: 700; }
        .action-btn-primary:hover { background: rgba(255,255,255,0.9); transform: translateY(-1px); }
        .action-btn-secondary { background: none; color: #ffffff; border: 1.5px solid rgba(255,255,255,0.2); }
        .action-btn-secondary:hover { border-color: rgba(255,255,255,0.5); background: rgba(255,255,255,0.05); }
        .section-card { margin: 0 auto 20px; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 24px 28px; max-width: 900px; width: calc(100% - 80px); }
        .section-title { font-size: 12px; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; color: #1DB954; margin-bottom: 12px; }
        .active-dot { width: 8px; height: 8px; border-radius: 50%; background: #1DB954; display: inline-block; margin-right: 6px; animation: pulse 2s infinite; }
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
        .playing-indicator { display: flex; align-items: flex-end; gap: 2px; height: 14px; }
        .playing-bar { width: 3px; background: #1DB954; border-radius: 2px; animation: playing 0.8s ease-in-out infinite alternate; }
        .playing-bar:nth-child(2) { animation-delay: 0.2s; }
        .playing-bar:nth-child(3) { animation-delay: 0.4s; }
        @keyframes playing { from { height: 3px; } to { height: 12px; } }
        .live-badge { background: #1DB954; color: #ffffff; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 100px; letter-spacing: 0.5px; }
        .see-all-btn { width: 100%; padding: 10px 0; border: none; background: none; color: rgba(255,255,255,0.4); font-size: 13px; cursor: pointer; font-family: 'DM Sans', sans-serif; font-weight: 600; margin-top: 4px; transition: color 0.2s; }
        .see-all-btn:hover { color: rgba(255,255,255,0.7); }
        .avatar-row { display: flex; gap: 12px; flex-wrap: wrap; }
        .avatar-item { display: flex; flex-direction: column; align-items: center; gap: 4px; cursor: pointer; transition: transform 0.2s; }
        .avatar-item:active { transform: scale(0.95); }
        .avatar-circle { width: 44px; height: 44px; border-radius: 50%; background: rgba(255,255,255,0.08); overflow: hidden; display: flex; align-items: center; justify-content: center; flex-shrink: 0; border: 1px solid rgba(255,255,255,0.1); }
      `}</style>

      <div className="home-hero">
        <div className="home-hero-glow" />
        <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
          {isVenueMode && (
            <span className="live-badge">{playerReady ? "LIVE" : "VENUE"}</span>
          )}
          <div className="home-venue-name">{venue?.name || "Venue"}</div>
          <div className="home-venue-sub">
            <span className="active-dot" />
            {activeUsers.length} here · {queue.length} songs queued
          </div>
        </div>

        {nowPlaying && (
          <div className="now-playing-card" onClick={() => setScreen("nowplaying")}>
            {nowPlaying.cover
              ? <img src={nowPlaying.cover} alt="" className="now-cover" />
              : <div className="now-cover-placeholder">🎵</div>
            }
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", color: "#1DB954", marginBottom: 2 }}>
                {isPlaying ? "Now Playing" : "Paused"}
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#ffffff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", letterSpacing: -0.3 }}>{nowPlaying.title}</div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 1 }}>{nowPlaying.artist}</div>
            </div>
            {isPlaying && (
              <div className="playing-indicator">
                <div className="playing-bar" /><div className="playing-bar" /><div className="playing-bar" />
              </div>
            )}
            <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 18 }}>›</span>
          </div>
        )}
      </div>

      <div className="action-grid">
        <button className="action-btn action-btn-primary" onClick={() => setScreen("search")}>+ Request Song</button>
        <button className="action-btn action-btn-secondary" onClick={() => setScreen("queue")}>🎵 Queue ({queue.length})</button>
        <button className="action-btn action-btn-secondary" onClick={() => setScreen("nowplaying")}>▶ Now Playing</button>
        <button className="action-btn action-btn-secondary" onClick={() => setScreen("venueusers")}>👥 Who's Here ({activeUsers.length})</button>
      </div>

      {queue.length > 0 && (
        <div className="section-card">
          <div className="section-title">Up Next</div>
          {queue.slice(0, 4).map((song, i) => (
            <div key={song.docId} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: i < Math.min(queue.length, 4) - 1 ? "1px solid rgba(255,255,255,0.06)" : "none" }}>
              <span style={{ width: 18, fontSize: 11, color: "rgba(255,255,255,0.3)", fontWeight: 700, flexShrink: 0 }}>#{i + 1}</span>
              {song.cover && <img src={song.cover} alt="" style={{ width: 34, height: 34, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#ffffff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{song.title}</div>
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>{song.artist}</div>
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, color: song.votes > 0 ? "#1DB954" : song.votes < 0 ? "#ff6b6b" : "rgba(255,255,255,0.3)", flexShrink: 0 }}>
                {song.votes > 0 ? `+${song.votes}` : song.votes}
              </div>
            </div>
          ))}
          {queue.length > 4 && (
            <button className="see-all-btn" onClick={() => setScreen("queue")}>
              See all {queue.length} songs →
            </button>
          )}
        </div>
      )}

      {activeUsers.length > 0 && (
        <div className="section-card">
          <div className="section-title">Who's Here</div>
          <div className="avatar-row">
            {activeUsers.slice(0, 8).map((u) => (
              <div key={u.uid} className="avatar-item" onClick={() => onOpenProfile(u.uid)}>
                <div className="avatar-circle">
                  {u.photoURL ? <img src={u.photoURL} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <span style={{ fontSize: 18 }}>👤</span>}
                </div>
                <span style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", maxWidth: 44, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{u.displayName?.split(" ")[0] || "User"}</span>
              </div>
            ))}
            {activeUsers.length > 8 && (
              <div className="avatar-item" onClick={() => setScreen("venueusers")}>
                <div className="avatar-circle">
                  <span style={{ fontSize: 12, fontWeight: 700, color: "rgba(255,255,255,0.5)" }}>+{activeUsers.length - 8}</span>
                </div>
                <span style={{ fontSize: 10, color: "rgba(255,255,255,0.4)" }}>more</span>
              </div>
            )}
          </div>
        </div>
      )}

      <div style={{ height: 8 }} />
    </div>
  );
}
